var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.614 8.147h2.097s.217-.663.289-1.62v-.148.074-.368H8.542v-2.36c0-.22.362-.59.65-.59h1.519V1H9.41C6.663 1 6.446 3.505 6.446 3.874v2.284H5v2.21h1.446V15h2.168V8.147z"}));
}

Fb.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Fb;

Fb.default = Fb;
